<template>
  <div class="breadcrumbs">
    <ul>
      <li>
        <nuxt-link to="/">
          <Icon name="home" />
        </nuxt-link>
      </li>
      <li v-for="(item, i) in props.items">
        <nuxt-link :to="item.path">
          <span>{{ item.title }}</span>
        </nuxt-link>
        <Icon v-if="i < props.items.length - 1" name="arrow-right" />
      </li>
    </ul>
  </div>
</template>

<script lang="ts" setup>
import type { Breadcrumb } from '~/lib/types'

const props = defineProps<{
  items: Breadcrumb[]
}>()
</script>

<style lang="scss">
.breadcrumbs {
  ul {
    padding: 0;
    margin: 0;
    list-style: none;
    display: flex;
    align-items: center;

    li {
      display: flex;
      align-items: center;
      gap: _rem(4px);
      margin-right: _rem(6px);

      &:first-child {
        padding-bottom: 3px;
        margin-right: _rem(8px);
      }

      a {
        opacity: 0.64;
        text-decoration: underline;
        display: flex;
        align-items: center;
      }
        &:last-child a, &:hover a {
          opacity: 1;
          text-decoration: none;
        }

      .icon--arrow-right {
        opacity: 0.64;
        width: _rem(10px);
        height: _rem(10px);
      }
    }
  }
}
</style>
